var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44971 7.54834C7.99316 7.00488 7.99316 6.12375 7.44971 5.58033L5.4817 3.61229C4.93825 3.06884 4.05712 3.06884 3.51367 3.61229C1.33985 5.78611 1.33985 9.31055 3.51367 11.4844L7.44971 15.4204C9.62353 17.5942 13.148 17.5942 15.3218 15.4204C15.8653 14.877 15.8653 13.9959 15.3218 13.4524L13.3538 11.4844C12.8103 10.9409 11.9292 10.9409 11.3857 11.4844L10.9017 11.9684C10.3583 12.5118 9.47716 12.5118 8.93371 11.9684L6.96571 10.0004C6.42225 9.45692 6.42225 8.57579 6.96571 8.03234L7.44971 7.54834Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0938 1.88379C13.9302 1.88379 17.0518 5.0054 17.0518 8.8418",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0938 4.66699C12.3994 4.66699 14.2686 6.53612 14.2686 8.8418",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPhone;